"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ORGANIZATION_INVITED_USER = exports.ORGANIZATION_UPDATED_PAYMENT_INFO = exports.ORGANIZATION_UPDATED_PRACTICE_AREA = exports.ORGANIZATION_UPDATED_BID_PRICE = exports.ORGANIZATION_TOGGLED_REFERRALS = exports.ORGANIZATION_CREATED = void 0;
exports.ORGANIZATION_CREATED = "organizationCreated";
exports.ORGANIZATION_TOGGLED_REFERRALS = "organizationToggledReferrals";
exports.ORGANIZATION_UPDATED_BID_PRICE = "organizationUpdatedBidPrice";
exports.ORGANIZATION_UPDATED_PRACTICE_AREA = "organizationUpdatedPracticeArea";
exports.ORGANIZATION_UPDATED_PAYMENT_INFO = "organizationUpdatedPaymentInfo";
exports.ORGANIZATION_INVITED_USER = "organizationInvitedUser";